import React, { useState } from "react";
import { BaseModal } from "../../../../atoms/base-modal";
import {
  PrimaryButton,
  SecondaryButton,
} from "@graffer-inc/console-design-kit";

export const OverwriteCustomPathModal: React.FC<{
  onUpdateSurvey: () => void;
  updateSurveyName: string;
  pathDuplicateSurveyName: string;
  onClose: () => void;
  isActive: boolean;
}> = ({
  onUpdateSurvey,
  updateSurveyName,
  pathDuplicateSurveyName,
  onClose,
  isActive,
}) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const updateSurvey = async () => {
    setIsSubmitting(true);
    try {
      await onUpdateSurvey();
      setIsSubmitting(false);
      onClose();
    } catch (e) {
      // onUpdateSurvey側でエラーをハンドリングしているため、ここではエラーをハンドリングしない
      setIsSubmitting(false);
    }
  };

  return (
    <BaseModal
      title={"カスタムパスが利用されています"}
      isActive={isActive}
      onClose={onClose}
    >
      <section className="modal-card-body">
        <div className="field">
          入力されたパスは現在「{pathDuplicateSurveyName}
          」で使用されています。更新すると、「{pathDuplicateSurveyName}
          」のパスの設定が解除され、「{updateSurveyName}」に割り当てられます。
        </div>
      </section>
      <footer className="modal-card-foot is-flex is-justify-content-center">
        <div className="mx-4">
          <SecondaryButton text="キャンセル" onClick={onClose} />
        </div>
        <div className="mx-4">
          <PrimaryButton
            text="更新する"
            isLoading={isSubmitting}
            onClick={updateSurvey}
          />
        </div>
      </footer>
    </BaseModal>
  );
};
